import axios from 'axios';
import swal from "sweetalert";
import {
    loginConfirmedAction,
    Logout,
} from '../store/actions/AuthActions';
import { var_api} from '../constant';

export function signUp(email, password) {
    const postData = {
        email,
        password,
        returnSecureToken: true,
    };
    return axios.post(
        `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=AIzaSyD3RPAp3nuETDn9OQimqn_YF6zdzqWITII`,
        postData,
    );
}

// export function login(email, password, role) {
//     const postData = { email, password };

//     let url = '';
//     if (role === 'superadmin') {
//         url = `https://test-api.veezzo.com/login/superadminlogin`;
//     } else if (role === 'cityadmin' || role === 'citymanager') {
//         url = `https://test-api.veezzo.com/login/cityadminlogin`;
//     } else {
//         swal("Error", "Invalid role selected", "error");
//         return Promise.reject(); // prevent further execution
//     }

//     return axios.post(url, postData);
// }
export function login(email, password, role) {
  const postData = { email, password };
  let url = '';

  if (role === 'veeadmin') {
    url = `${var_api}login/veemartadminlogin`;
  } else if (role === 'user' || role === 'citymanager') {
    url = `${var_api}login/warehouse-login`;
  } else if (role === 'vendor') {
    url = `${var_api}login/vendoradminlogin`; // shared for shopadmin & shopmanager
  } else {
    swal("Error", "Invalid role selected", "error");
    return Promise.reject("Invalid role");
  }

  return axios.post(url, postData);
}



export function formatError(errorResponse) {
    switch (errorResponse.error.message) {
        case 'EMAIL_EXISTS':
            swal("Oops", "Email already exists", "error");
            break;
        case 'EMAIL_NOT_FOUND':
            swal("Oops", "Email not found", "error", { button: "Try Again!" });
            break;
        case 'INVALID_PASSWORD':
            swal("Oops", "Invalid Password", "error", { button: "Try Again!" });
            break;
        case 'USER_DISABLED':
            return 'User Disabled';
        default:
            return '';
    }
}

// export function saveTokenInLocalStorage(data) {
//   const expireDate = new Date(new Date().getTime() + 3600 * 1000); // 1 hour from now

//   const userDetails = {
//     token: data.token,
//     user: data.user,
//     expireDate,
//   };

//   // Store whole object
//   localStorage.setItem('userDetails', JSON.stringify(userDetails));

//   // Store individual fields for quick access
//   const { token, user } = data;

//   localStorage.setItem('token', token);
//   localStorage.setItem('user_id', user.id);
//   localStorage.setItem('name', user.name);
//   localStorage.setItem('mobile', user.mobile);
//   localStorage.setItem('email', user.email);
//   localStorage.setItem('role', user.role);
//   localStorage.setItem('created_at', user.created_at);
//   localStorage.setItem('updated_at', user.updated_at);
//   localStorage.setItem('expireDate', expireDate);

//   // Additional user fields
//   localStorage.setItem('shop_id', user.shop_id);

//   localStorage.setItem('district_id', user.district_id);
//   localStorage.setItem('city_id', user.city_id);
//   localStorage.setItem('business_id', user.business_id);
//   localStorage.setItem("zone_id", user.zone_id);
// localStorage.setItem("vendor_id", user.vendor_id);
// localStorage.setItem("area_id", user.area_id);

//   localStorage.setItem('image', user.image);
//   localStorage.setItem('additional_note', user.additional_note || '');
//   localStorage.setItem('dob', user.dob);
//   localStorage.setItem('gender', user.gender);
//   localStorage.setItem('blood_group', user.blood_group);
//   localStorage.setItem('marital_status', user.marital_status);
//   localStorage.setItem('address', user.address);
//   localStorage.setItem('active_status', user.active_status);
//   localStorage.setItem('cat_id', user.cat_id);
//   localStorage.setItem('product_id', user.product_id);

//   localStorage.setItem("warehouse_token", data.token);
//   localStorage.setItem("warehouse_user", JSON.stringify(data.user));
//   localStorage.setItem("warehouse_id", user.warehouse_id);
//   localStorage.setItem("warehouse_name",user.name);
//   localStorage.setItem("warehouse_role", user.role);
//   localStorage.setItem("warehouse_email", user.email_id);
//   localStorage.setItem("warehouse_contact", user.contact_no1);





  
// }

export function saveTokenInLocalStorage(data) {
  const expireDate = new Date(new Date().getTime() + 3600 * 1000); // 1 hour

  const user = data.user;
  const warehouse = data.warehouse;

  const userDetails = {
    token: data.token,
    user: data.user,
    warehouse: data.warehouse,
    expireDate,
  };

  // Store whole object
  localStorage.setItem('userDetails', JSON.stringify(userDetails));

  // Store individual fields
  localStorage.setItem('token', data.token);
  localStorage.setItem('user_id', user.id);
  localStorage.setItem('name', user.name);
  localStorage.setItem('mobile', user.contact_no1);
  localStorage.setItem('email', user.email_id);
  localStorage.setItem('role', user.role);
  localStorage.setItem('created_at', user.created_at);
  localStorage.setItem('updated_at', user.updated_at);
  localStorage.setItem('expireDate', expireDate);

  // User-related Warehouse IDs
  localStorage.setItem('warehouse_id', user.warehouse_id);

  // Warehouse Details
  localStorage.setItem("warehouse_token", data.token);
  localStorage.setItem("warehouse_user", JSON.stringify(user));
  localStorage.setItem("warehouse_data", JSON.stringify(warehouse));

  // FIXED → Correct warehouse fields from payload
  localStorage.setItem("login_id", warehouse.id);
  localStorage.setItem("warehouse_name", warehouse.warehouse_name);
  localStorage.setItem("warehouse_full_address", warehouse.warehouse_full_address);
  localStorage.setItem("warehouse_latitude", warehouse.warehouse_latitude);
  localStorage.setItem("warehouse_longitude", warehouse.warehouse_longitude);
  localStorage.setItem("warehouse_no", warehouse.warehouse_no);
  localStorage.setItem("warehouse_city_id", warehouse.city_id);
  localStorage.setItem("warehouse_is_active", warehouse.is_active);
  localStorage.setItem("warehouse_remark", warehouse.remarks);

  // FIXED → Correct user fields from payload
  localStorage.setItem("warehouse_role", user.role);
  localStorage.setItem("warehouse_email", user.email_id);
  localStorage.setItem("warehouse_contact", user.contact_no1);
}



export function runLogoutTimer(dispatch, timer, navigate) {
    setTimeout(() => {
        dispatch(Logout(navigate));
    }, timer);
}

export function checkAutoLogin(dispatch, navigate) {
    const tokenDetailsString = localStorage.getItem('userDetails');
    if (!tokenDetailsString) {
        // Don't navigate — just leave them at login
        return;
    }

    const tokenDetails = JSON.parse(tokenDetailsString);
    const expireDate = new Date(tokenDetails.expireDate);
    const todaysDate = new Date();

    if (todaysDate > expireDate || !tokenDetails?.user) {
        localStorage.removeItem("userDetails"); // remove expired
        return;
    }

    dispatch(loginConfirmedAction(tokenDetails));

    // Optional navigation if needed
    const userRole = tokenDetails.user.role;
    // if (userRole === 'superadmin' && window.location.pathname !== '/super-admin-dashboard') {
    //     navigate('/super-admin-dashboard');
    // } else if (userRole === 'cityadmin' && window.location.pathname !== '/city-dashboard') {
    //     navigate('/city-dashboard');
    // }

    // Set logout timer
    const timer = expireDate.getTime() - todaysDate.getTime();
    runLogoutTimer(dispatch, timer, navigate);
}

